import permission from '@js/libs/permissions';

export default {
    hasUser() {
        return this.authUser != null;
    },

    authUser() {
        return this.$store.getters[`${this.$authPluginNamespace}/user`];
    },

    userPermissions() {
        return this.$store.getters[
            `${this.$authPluginNamespace}/userPermissions`
        ];
    },

    userRoles() {
        return this.$store.getters[`${this.$authPluginNamespace}/userRoles`];
    },

    userOutlets() {
        return this.$store.getters[`${this.$authPluginNamespace}/userOutlets`];
    },

    permission() {
        return permission;
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/auth/lib/mixins/computed.js